import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCheck, faCheck, faCalendarCheck, faUserCircle, faFaceSmile, faSignature, faArrowDown19, faArrowDownAZ,
         faHouse, faPaperPlane, faEnvelope, faChalkboardTeacher, faCirclePlay, faComment, faCommentDots,
         faBrain, faHeadphones, faCirclePlus } from "@fortawesome/free-solid-svg-icons";


const MaxiIcon = ({iconName, className}) => {
    const getFontAwesomeIcon = (iconName) => {
        switch (iconName) {
            case 'faUserCheck':
                return faUserCheck;
            case 'faCheck':
                return faCheck;
            case 'faCalendarCheck':
                return faCalendarCheck;
            case 'faUserCircle':
                return faUserCircle;
            case 'faFaceSmile':
                return faFaceSmile;
            case 'faSignature':
                return faSignature;
            case 'faArrowDown19':
                return faArrowDown19;
            case 'faArrowDownAZ':
                return faArrowDownAZ;
            case 'faHouse':
                return faHouse;
            case 'faPaperPlane':
                return faPaperPlane
            case 'faEnvelope':
                return faEnvelope;
            case 'faChalkboardTeacher':
                return faChalkboardTeacher;
            case 'faCirclePlay':
                return faCirclePlay;
            case 'faComment':
                return faComment;
            case 'faCommentDots':
                return faCommentDots;
            case 'faBrain':
                return faBrain;
            case 'faHeadphones':
                return faHeadphones;
            case 'faCirclePlus':
                return faCirclePlus;
            default:
                return faFaceSmile;
        }
    }

    return (
        <FontAwesomeIcon icon={getFontAwesomeIcon(iconName)} className={className} />
    );
}

export default MaxiIcon;